import React, { useState, useEffect } from 'react';
import { getPublishedNote } from '../api';

export default function PublishedNote({ slug }) {
  const [note, setNote] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await getPublishedNote(slug);
        setNote(data);
      } catch (e) {
        setError(e.response?.status === 404 ? 'This note is not published or has been removed.' : 'Failed to load note.');
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  if (loading) {
    return (
      <div className="published-note-page">
        <div className="published-note-container">
          <div className="animate-pulse space-y-3 pt-16">
            <div className="h-8 w-1/3 rounded bg-zinc-200" />
            <div className="h-4 w-3/4 rounded bg-zinc-200" />
            <div className="h-4 w-full rounded bg-zinc-200" />
            <div className="h-4 w-5/6 rounded bg-zinc-200" />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="published-note-page">
        <div className="published-note-container">
          <div className="flex flex-col items-center justify-center pt-32 text-zinc-500">
            <p className="text-lg font-medium text-zinc-950">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="published-note-page">
      <div className="published-note-container">
        <div className="published-note-header">
          {note.emoji && <span className="published-note-emoji">{note.emoji}</span>}
          <h1 className="published-note-title">{note.title || 'Untitled'}</h1>
        </div>
        <div
          className="published-note-content"
          dangerouslySetInnerHTML={{ __html: note.content }}
        />
      </div>
    </div>
  );
}
